<template>
  <div>
    <template v-if="status">
      <div v-if="status.name">
        {{ status.name }}
      </div>
      <div
        v-if="status.name"
        class="status text-muted"
      >
        <span>{{ status.active }} / {{ status.total }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GroupStatus',
  props: {
    place: {
      required: true,
      type: Object,
    },
    group: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters([
      'getGroupedVars',
      'getVarById',
    ]),
    groupedVars() {
      const grupedVars = this.getGroupedVars[this.group.id];
      if (!grupedVars) {
        return [];
      }
      return grupedVars.map(varId => this.getVarById(varId)).filter(
        v => v.placeLft >= this.place.lft
          && v.placeRght <= this.place.rght,
      );
    },
    status() {
      if (this.groupedVars.length === 0) {
        return null;
      }
      return {
        name: this.groupedVars[0].actorsTitle,
        active: this.groupedVars.filter(v => (!isNaN(v.value) && v.value > 0) || v.value).length,
        total: this.groupedVars.length,
      };
    },
  },
};
</script>

<style scoped>

</style>
